import React, {useState} from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import useProvideAuth from '../hooks/useAuth';

export default function LoginPage(){
  const [email,setEmail]=useState('mgr@demo.com');
  const [password,setPassword]=useState('M@nger123');
  const auth = useProvideAuth();
  console.log('auth', auth);

  async function submit(e){
    e.preventDefault();
    try {
      await auth.login(email,password);
      window.location.href = '/';
    } catch(err){
      alert('Login failed: '+(err?.response?.data?.error || err.message));
    }
  }

  return (
    <Paper elevation={3} sx={{p:4, maxWidth:480, margin:'40px auto'}}>
      <Box sx={{display:'flex', flexDirection:'column', alignItems:'center'}}>
        <Avatar sx={{m:1, bgcolor:'primary.main'}}><LockOutlinedIcon/></Avatar>
        <Typography component="h1" variant="h5">Sign in</Typography>
      </Box>
      <Box component="form" onSubmit={submit} sx={{mt:2}}>
        <TextField label="Email" value={email} onChange={(e)=>setEmail(e.target.value)} fullWidth margin="normal" />
        <TextField label="Password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} fullWidth margin="normal" />
        <Button type="submit" variant="contained" fullWidth sx={{mt:2}}>Sign In</Button>
      </Box>
    </Paper>
  );
}
